export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11461.07baf311.jpg";